import React, { useEffect, useState } from "react";

import cn from "classnames";
import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import styles from "./Components.module.sass";
import Confirm from "../../../components/Confirm";
import TemplateModal from "../../NewProduct/TemplateModal";
import CreateCollection from "../../Collection/CreateCollection";

import { UseApi } from "../../../hooks/use-api";
import { useUser } from "../../../context";
import { listGenerator } from "..";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import {
	DeleteCollection,
	GetCollections,
	UpdateCollection,
} from "../../../Services/lib/nft";

import coll_ from "../../../i11/Collection";
import Loader from "../../../components/Loader";

const filter = {
	page: 1,
	limit: 50,
	name: "",
	status: "SCHEDULE",
	order_direction: "DESC",
};

const CostomizeProductCollection = () => {
	const { locale } = useUser();

	const [initial, setInitial] = useState();
	const [collection, setCollection] = useState([]);

	const {
		isOpen: createV,
		onOpen: createO,
		onClose: createC,
	} = UseDisclosure();

	const [{ isLoading, error }, getCollections] = UseApi({
		service: GetCollections,
	});

	const getCollection_ = async () => {
		const res = await getCollections(filter);
		if (res) {
			setCollection(res.list);
		}
	};
	const CloseC_ = () => {
		createC();
		setInitial();
	};
	const CloseC = () => {
		CloseC_();
		getCollection_();
	};

	const setEdit = (item) => {
		const body = {
			_id: item._id,
			name: item.name || "",
			description: item.description || "",
			image: item.image || "",
			startDate: item.startDate || "",
			endDate: item.endDate || "",
			nftTemplates: item.nftTemplates,
			drawHtml: item.drawHtml || "",
		};

		for (const [key, value] of Object.entries(body)) {
			if (!value) delete body[key];
		}
		setInitial(body);
		createO();
	};

	useEffect(() => {
		getCollection_();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (error) return <div />;

	if (isLoading)
		return (
			<div className={styles.p150}>
				<div
					className={cn(styles.busyContainer, styles.h350)}
					size={24}
				/>
				<br />
				<div
					style={{
						display: "flex",
						margin: " 0 -30px",
					}}
				>
					{listGenerator(3).map((e) => {
						return <div className={styles.tokenStoreCat}></div>;
					})}
				</div>
			</div>
		);
	return (
		<div>
			<div className={styles.ph}>
				{collection?.length > 0 && (
					<CCard
						item={collection[0]}
						reload={getCollection_}
						edit={() => setEdit(collection[0])}
						big
					/>
				)}
			</div>
			<br />

			<div style={{ display: "flex", padding: "0 120px" }}>
				<Icon
					name="arrow-down"
					size="32"
					className={cn(styles.rotate90, styles.verMargin)}
				/>
				<div className={styles.flex}>
					{collection.map((item, i) => {
						if (i === 0) return <div />;
						return (
							<CCard
								key={`_card_${i}`}
								item={item}
								edit={setEdit}
								reload={getCollection_}
							/>
						);
					})}
				</div>
				<Icon
					name="arrow-next"
					size="32"
					className={styles.verMargin}
				/>
			</div>
			<br />

			<button
				className="button-stroke button-small"
				style={{ display: "flex", margin: "0 auto" }}
				onClick={createO}
			>
				<Icon name="add" size={24} />
				{coll_[locale].create_collection}
			</button>
			<br />
			<br />
			<TemplateModal visible={createV} onClose={CloseC_}>
				{createV && (
					<CreateCollection
						type="Published"
						initialVal={initial}
						close={CloseC}
						noDraft
					/>
				)}
			</TemplateModal>
		</div>
	);
};

const CCard = ({ item, big, edit, reload }) => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();

	const [{ isLoading }, delete_] = UseApi({
		service: DeleteCollection,
		successMsg: "Collection successfully deleted",
	});

	const [{ isLoading: loadingHide }, hide] = UseApi({
		service: UpdateCollection,
		successMsg: "`Successfully",
	});

	const onConfirm = async () => {
		const res = await delete_(item._id);
		if (res) {
			onClose();
			reload();
		}
	};

	const hideController = async () => {
		const res = await hide({
			_id: item._id,
			is_hide: !item.is_hide,
		});
		if (res) {
			reload();
		}
	};

	const hoverButtons = (
		<div className={styles.hoverEdit}>
			<button type="button" onClick={onOpen}>
				<Icon size="24" name="trash" fill="white" />
			</button>

			<button type="button" onClick={() => hideController()}>
				{loadingHide ? (
					<Loader />
				) : (
					<Icon svgImage={item.is_hide ? "hideEye" : "eye"} />
				)}
			</button>
			<button type="button" onClick={() => edit(item)}>
				<Icon size="24" name="edit" fill="white" />
			</button>
		</div>
	);
	const modal = (
		<Modal visible={isOpen} onClose={onClose}>
			<Confirm
				title={"This action will delete collection"}
				onCancel={onClose}
				onConfirm={onConfirm}
				isLoading={isLoading}
			/>
		</Modal>
	);
	if (big) {
		return (
			<>
				<div className={styles.card} style={{ width: "100%" }}>
					<img
						className={styles.imageStyle}
						src={item.image}
						style={{ width: "100%", height: "350px" }}
						alt="_collection_big_img"
					/>

					{item?.is_hide && (
						<div className={styles.hide}>
							<Icon svgImage="hideEye" />
						</div>
					)}
					<div className={styles.imageCom}>
						<div className={styles.textStyleP}>{item.name}</div>
						<button>{coll_[locale].shop_now}</button>
					</div>
					{hoverButtons}
				</div>
				{modal}
			</>
		);
	}

	return (
		<div className={styles.columnCon}>
			<div className={styles.card} style={{ margin: "0" }}>
				<img
					className={styles.collectionImage}
					src={item.image}
					alt="_collectionIMG"
				/>
				{item?.is_hide && (
					<div className={styles.hide}>
						<Icon svgImage="hideEye" />
					</div>
				)}
				{hoverButtons}
			</div>
			<div className={styles.name}>{item.name}</div>
			<div className={styles.desc}>{item.description}</div>
			<button className={styles.but}>{coll_[locale].learn_more}</button>
			{modal}
		</div>
	);
};

export default CostomizeProductCollection;
